import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';

import MaterialTable from 'material-table';
import Tooltip from '@material-ui/core/Tooltip';

import ActionBar from '../../components/ActionBar';

import { fetchSubscriptions } from '../../actions/subscriptionActions';

import EditSubscriptionModal from '../Modals/EditSubscriptionModal';
import UserSubscriptionTableRowMenu from './UserSubscriptionsTableRowMenu';

import classes from './UserSubscriptionPage.module.css';

const UserSubscriptionPage = ({
    userSubscriptions,
    ...props
}) => {

    const [filteredSubscriptions, setFilteredSubscriptions] = useState([]);
    const [searchFilter, setSearchFilter] = useState(null);
    const [editSubscriptionModalOpen, setEditSubscriptionModalOpen] = useState(false);

    useEffect(() => {
        setFilteredSubscriptions(userSubscriptions);
    }, []);

    useEffect(() => {
        searchEngine(searchFilter);
    }, [userSubscriptions]);


    const handleSearch = searchFilter => {
        if (searchFilter) {
            setSearchFilter(searchFilter);
        }

        searchEngine(searchFilter);
    };

    const searchEngine = searchFilter => {
        let searchResults = [];

        if (!searchFilter) {
            setFilteredSubscriptions(userSubscriptions);
            return;
        }

        userSubscriptions.forEach(userSubscription => {
            if (_.includes(userSubscription, null)) {
                return;
            }

            const values = Object.values(userSubscription);
            const lowercaseValues = values.filter(item => _.isString(item)).map(value => value.toLowerCase());

            lowercaseValues.forEach(value => {
                if (_.includes(value, searchFilter.toLowerCase())) {
                    searchResults.push(userSubscription);
                }
            });

            searchResults = _.uniq(searchResults);
        });

        setFilteredSubscriptions(searchResults);
    };

    const handleEmailColumn = subscription => {
        const email = _.get(subscription, 'email', '');

        if (email) {
            if (_.get(subscription, 'emailConfirmed', '')) {
                return (
                    <Tooltip
                        title={
                            <React.Fragment>
                                <span className={classes.tooltip}>Confirmed</span>
                            </React.Fragment>
                        }
                        placement="top-start"
                    >
                        <img src="/assets/images/billing-ok.svg" alt="subscription" />
                    </Tooltip>);
            }
            return (
                <Tooltip
                    title={
                        <React.Fragment>
                            <span className={classes.tooltip}>Unconfirmed</span>
                        </React.Fragment>
                    }
                    placement="top-start"
                >
                    <img src="/assets/images/billing-delinquent.svg" alt="subscription" />
                </Tooltip>);
        }
    };

    const handleEntityName = subscription => {
        const entityType = _.get(subscription, 'entityType', '');

        switch (entityType) {
            case 'esmscompany':
                return 'Company';
            case 'esmsclient':
                return 'Client';
            case 'esmssite':
                return 'Site';
            case 'esmsequipment':
                return 'Equipment';
            case 'esmssystem':
                return 'System';
            case 'esmscampus':
                return 'Campus';
            case 'esmsarea':
                return 'Area';
            default:
                return '';
        }
    };

    const handleRuleColumn = subscription => {
        if (subscription.ruleName) {
            return subscription.ruleName;
        }
        else {
            return '';
        }
    };

    const toggleEditModal = toggle => {
        setEditSubscriptionModalOpen(toggle);
    };

    const handleSMSColumn = subscription => {
        const sms = _.get(subscription, 'sms', '');

        if (sms) {
            return <img src="/assets/images/billing-ok.svg" alt="subscription" />;
        }
    };

    const renderTableMenu = subscription => {
        return (
            <UserSubscriptionTableRowMenu
                subscription={subscription}
                openEditModal={() => toggleEditModal(true)}
            />
        );
    };

    return (
        <React.Fragment>
            <Paper className={classes.UserSubscriptionPage}>
                <header className={classes.bodyHeader}>
                    <div className={classes.title}>
                        <img className={classes.headerIcon} src="/assets/images/userContactHeaderIcon.svg" alt="" />
                        <span>My Subscriptions</span>
                    </div>
                </header>
                <ActionBar
                    onSearch={handleSearch}
                />

                <div className={classes.UserSubscriptionTable}>
                    <MaterialTable
                        options={{
                            paging:    false,
                            showTitle: false,
                            search:    false,
                            selection: false,
                            toolbar:   false
                        }}
                        columns={[
                            { title: 'Target', field: 'target' },
                            {
                                title:  'Entity',
                                field:  'entityType',
                                render: subscription => handleEntityName(subscription)
                            },
                            {
                                title:  'Rule',
                                field:  'ruleName',
                                render: subscription => handleRuleColumn(subscription)
                            },
                            {
                                title:  'Email',
                                render: subscription => handleEmailColumn(subscription)
                            },
                            {
                                title:  'SMS',
                                render: subscription => handleSMSColumn(subscription)
                            },
                            {
                                title:  '',
                                render: subscription => renderTableMenu(subscription)
                            }
                        ]}
                        data={filteredSubscriptions}
                    />
                </div>
            </Paper>
            <EditSubscriptionModal
                open={editSubscriptionModalOpen}
                close={() => toggleEditModal(false)}
                title="Update Subscription"
            />
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        userSubscriptions: state.subscription.userSubscriptions
    };
};

const mapDispatchToProps = {
    fetchSubscriptions
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSubscriptionPage);
